import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone, MessageCircle } from 'lucide-react';
export function CtaBanner() {
  return <section className="relative py-32 overflow-hidden bg-stone-100 dark:bg-[#222222] border-y border-stone-400 dark:border-[#333333]" data-id="element-398">
      {/* Subtle Grain Texture Overlay */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none mix-blend-overlay dark:mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} data-id="element-399" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-400">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-401">
          {/* Left: Massive Heading */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="lg:col-span-7" data-id="element-402">
            <h2 className="font-heading text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] font-extrabold text-stone-900 dark:text-white tracking-tighter leading-[1.05]" data-id="element-403">
              Need gravel <br data-id="element-404" />
              <span className="text-brand-orange" data-id="element-405">delivered today?</span>
            </h2>
          </motion.div>

          {/* Right: Actions & Supporting Text */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1],
          delay: 0.1
        }} className="lg:col-span-5 lg:pl-12 flex flex-col justify-center" data-id="element-406">
            <p className="text-xl text-stone-800 dark:text-stone-300 font-medium mb-10 leading-relaxed font-sub" data-id="element-407">
              Skip the wait. We offer fast, reliable delivery across the Puget
              Sound area. Same-day service available in most zones.
            </p>

            <div className="flex flex-row flex-wrap gap-3" data-id="element-408">
              <a href="#" onClick={e => {
              e.preventDefault();
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }} className="group flex items-center justify-center bg-brand-button text-white hover:bg-brand-buttonHover px-6 py-3.5 rounded-xl font-bold text-sm transition-all duration-300 whitespace-nowrap" data-id="element-409">
                Get Instant Quote
                <ArrowRight className="w-4 h-4 ml-1.5 group-hover:translate-x-0.5 transition-transform" data-id="element-410" />
              </a>

              <a href="tel:206-619-3742" className="flex items-center justify-center bg-transparent border border-stone-400 dark:border-white/20 hover:border-stone-500 dark:hover:border-white/40 hover:bg-stone-200/50 dark:hover:bg-white/5 text-stone-900 dark:text-white px-6 py-3.5 rounded-xl font-bold text-sm transition-all duration-300 whitespace-nowrap" data-id="element-411">
                <Phone className="w-4 h-4 mr-1.5 text-brand-orange" data-id="element-412" />
                (206) 619-3742
              </a>

              <a href={`sms:2066193742?body=${encodeURIComponent('Hi! I have a question about 253 Gravel.')}`} className="flex items-center justify-center bg-transparent border border-stone-400 dark:border-white/20 hover:border-stone-500 dark:hover:border-white/40 hover:bg-stone-200/50 dark:hover:bg-white/5 text-stone-900 dark:text-white px-6 py-3.5 rounded-xl font-bold text-sm transition-all duration-300 whitespace-nowrap" data-id="element-413">
                <MessageCircle className="w-4 h-4 mr-1.5 text-brand-orange" data-id="element-414" />
                Text Us
              </a>
            </div>

            <div className="mt-6 flex items-center text-sm text-stone-700 font-medium" data-id="element-415">
              <div className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-pulse" data-id="element-416" />
              Dispatch is currently active
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}